import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_FORMTEMPLATEFILETYPE_LOAD,
    ACTION_FORMTEMPLATEFILETYPE_LOAD_BY_ID,
    ACTION_FORMTEMPLATEFILETYPE_LOAD_FAILURE,
    ACTION_FORMTEMPLATEFILETYPE_LOAD_SUCCESS,

    ACTION_FORMTEMPLATEFILETYPE_SAVE,
    ACTION_FORMTEMPLATEFILETYPE_SAVE_SUCCESS,
    ACTION_FORMTEMPLATEFILETYPE_SAVE_FAILURE,

    ACTION_FORMTEMPLATEFILETYPE_CREATE,
    ACTION_FORMTEMPLATEFILETYPE_CREATE_SUCCESS,
    ACTION_FORMTEMPLATEFILETYPE_CREATE_FAILURE,

    ACTION_FORMTEMPLATEFILETYPE_VALIDATE,
    ACTION_FORMTEMPLATEFILETYPE_VALIDATE_SUCCESS,
    ACTION_FORMTEMPLATEFILETYPE_VALIDATE_FAILURE,

    ACTION_FORMTEMPLATEFILETYPE_CLEAR,
    ACTION_FORMTEMPLATEFILETYPE_FILTER,

    FormTemplateFileTypeAction
} from '../actions/formTemplateFileTypes';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IFormTemplateFileTypeState {
    formData: Dtos.FormTemplateFileType | Dtos.FormTemplateFileType[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[];
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.FormTemplateFileType[];
}

const initialState: IFormTemplateFileTypeState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: []
};


function loading(state: IFormTemplateFileTypeState, _isLoading: boolean): IFormTemplateFileTypeState {
    const newState: IFormTemplateFileTypeState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IFormTemplateFileTypeState,
    formData: Dtos.FormTemplateFileType | Dtos.FormTemplateFileType[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IFormTemplateFileTypeState {
    const newState: IFormTemplateFileTypeState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: IFormTemplateFileTypeState, formFilter: IFormFilter): IFormTemplateFileTypeState {

    const interests: Dtos.FormTemplateFileType[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = interests ? interests.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: IFormTemplateFileTypeState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        }
    });

    return newState;
}

function loadFailure(state: IFormTemplateFileTypeState, responseStatus: Dtos.ResponseStatus): IFormTemplateFileTypeState {
    const newState: IFormTemplateFileTypeState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IFormTemplateFileTypeState, propertiesToClear?: string[]): IFormTemplateFileTypeState {

    if (!propertiesToClear) {
        let formFilter = state.formFilter;
        const newState: IFormTemplateFileTypeState = update(initialState, {
            formFilter: {
                $set: formFilter
            }
        });
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IFormTemplateFileTypeState, _isSaving: boolean): IFormTemplateFileTypeState {
    const newState: IFormTemplateFileTypeState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IFormTemplateFileTypeState,
    formData: Dtos.FormTemplateFileType | Dtos.FormTemplateFileType[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IFormTemplateFileTypeState {
    const newState: IFormTemplateFileTypeState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IFormTemplateFileTypeState, responseStatus: Dtos.ResponseStatus): IFormTemplateFileTypeState {
    const newState: IFormTemplateFileTypeState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IFormTemplateFileTypeState, _isCreating: boolean): IFormTemplateFileTypeState {
    const newState: IFormTemplateFileTypeState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IFormTemplateFileTypeState,
    formData: Dtos.FormTemplateFileType,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IFormTemplateFileTypeState {
    const newState: IFormTemplateFileTypeState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IFormTemplateFileTypeState, responseStatus: Dtos.ResponseStatus): IFormTemplateFileTypeState {
    const newState: IFormTemplateFileTypeState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: IFormTemplateFileTypeState, _isValidating: boolean): IFormTemplateFileTypeState {
    const newState: IFormTemplateFileTypeState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: IFormTemplateFileTypeState,
    formData: Dtos.FormTemplateFileType,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IFormTemplateFileTypeState {
    const newState: IFormTemplateFileTypeState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: IFormTemplateFileTypeState, responseStatus: Dtos.ResponseStatus): IFormTemplateFileTypeState {
    const newState: IFormTemplateFileTypeState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const FormTemplateFileTypeReducer: Reducer<IFormTemplateFileTypeState> = (state: IFormTemplateFileTypeState = initialState, action: FormTemplateFileTypeAction) => {
    switch (action.type) {
        case ACTION_FORMTEMPLATEFILETYPE_LOAD:
        case ACTION_FORMTEMPLATEFILETYPE_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_FORMTEMPLATEFILETYPE_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_FORMTEMPLATEFILETYPE_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_FORMTEMPLATEFILETYPE_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_FORMTEMPLATEFILETYPE_SAVE:
            return saving(state, true);
        case ACTION_FORMTEMPLATEFILETYPE_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_FORMTEMPLATEFILETYPE_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_FORMTEMPLATEFILETYPE_CREATE:
            return creating(state, true);
        case ACTION_FORMTEMPLATEFILETYPE_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_FORMTEMPLATEFILETYPE_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_FORMTEMPLATEFILETYPE_VALIDATE:
            return validating(state, true);
        case ACTION_FORMTEMPLATEFILETYPE_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_FORMTEMPLATEFILETYPE_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_FORMTEMPLATEFILETYPE_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default FormTemplateFileTypeReducer;